import { routes as attendance } from "@/modules/attendance";
import { routes as auth } from "@/modules/auth";
import { routes as axis } from "@/modules/axis";
import { routes as calendar } from "@/modules/calendar";
import { routes as city } from "@/modules/city";
import { routes as diagnostic } from "@/modules/diagnostic";
import { routes as evidence } from "@/modules/evidence";
import { routes as groupSolution } from "@/modules/group-solution";
import { routes as paymentManagement } from "@/modules/payment-management";
import { routes as pmd } from "@/modules/pmd";
import { routes as project } from "@/modules/project";
import { routes as referenceTerm } from "@/modules/reference-term";
import { routes as report } from "@/modules/report";
import { routes as task } from "@/modules/task";
import { routes as user } from "@/modules/user";
import { routes as event } from "@/modules/event";
import { routes as administrativeReport } from "@/modules/administrative-report";
import { routes as administrativeDashboard } from "@/modules/administrative-dashboard";
import { routes as ur } from "@/modules/ur";
import { routes as eixos } from "@/modules/eixo";
import { routes as pacote } from "@/modules/pacote";
import { routes as tema } from "@/modules/tema";
import { routes as salaIndicadores } from "@/modules/sala-indicadores";
import { routes as salaIndicadoresMunicipio } from "@/modules/sala-indicadores-municipio";
import { routes as salaIndicadoresApuracao } from "@/modules/sala-indicadores-apuracao";
import { routes as salaIndicadoresFonte } from "@/modules/sala-indicadores-fonte";
import { routes as salaIndicadoresLeitura } from "@/modules/sala-indicadores-leitura";
import { routes as salaIndicadoresNivel } from "@/modules/sala-indicadores-nivel";
import { routes as salaIndicadoresUnidade } from "@/modules/sala-indicadores-unidade";
import { routes as salaPrincipal } from "@/modules/sala-principal";
import { routes as cargosFuncoes } from "@/modules/cargos-funcoes";
import { routes as sala5w2h } from "@/modules/sala-5w2h";
import { routes as salaCusto } from "@/modules/sala-custo";
import { routes as salaTempo } from "@/modules/sala-tempo";
import { routes as pergunta } from "@/modules/pergunta";
import { routes as medalha } from "@/modules/medalha";
import { routes as configuracoes } from "@/modules/configuracao";
import { routes as groups } from "@/modules/groups";
import { routes as agenteTerritorial } from "@/modules/agenteTerritorial";
import { routes as eixosGrupo } from "@/modules/eixosGrupo";
import { routes as municipiosPorEixos } from "@/modules/municipioEixos";
import { routes as diagnosticoSelo } from "@/modules/diagnosticoSelo";
import { routes as tipoSolucao } from "@/modules/tipoSolucao";
import { routes as clienteOculto } from "@/modules/clienteOculto";
import { routes as categorias } from "@/modules/categoria";
import { routes as instituicao } from "@/modules/instituicao";
import { routes as gestaoTerritorios } from "@/modules/gestao-territorios";
import { routes as faixas } from "@/modules/faixas";
import { routes as escola } from "@/modules/escolas";
import { routes as contratos } from "@/modules/contratos";
import { routes as sp } from "@/modules/sp";
import { routes as municipiosTemasHabilitados } from "@/modules/municipiosTemasHabilitados";
import { routes as municipiosAds } from "@/modules/municipioAds";
import { routes as recurso } from "@/modules/resource";
import { routes as technicalReview } from "@/modules/technical-review";
import { routes as resourceDashboard } from "@/modules/resource-dashboard";
import { routes as technicalReviewDashboard } from "@/modules/technical-review-dashboard";
import { routes as gestaoProjetos } from "@/modules/gestao-projetos";
import { routes as support } from "@/modules/support";
import { routes as iaColetaEvidencias } from "@/modules/ia-coleta-evidencias";
import { routes as analiseEvidenciasIa } from "@/modules/analise-evidencias-ia";
import { routes as apresentacoes } from "@/modules/apresentacoes";
import { routes as analiseRelatoriosIa } from "@/modules/analise-relatorios-ia";
import { routes as cidadeEmpreendedoraNews } from "@/modules/cidade-empreendedora-news";
import { routes as ec2Codex } from "@/modules/ec2-codex";
import { routes as radarExecucao } from "@/modules/radar-execucao";
import { routes as orcamento } from "@/modules/orcamento";
import { routes as observagovCompras } from "@/modules/observagov-compras/routes";
import { routes as seloFechamento } from "@/modules/selo-fechamento";

export default [
  {
    path: "*",
    redirect: "/cidade",
  },
  ...attendance,
  ...auth,
  ...observagovCompras,
  ...seloFechamento,
  ...support,
  ...axis,
  ...calendar,
  ...city,
  ...diagnostic,
  ...evidence,
  ...groupSolution,
  ...paymentManagement,
  ...pmd,
  ...project,
  ...referenceTerm,
  ...report,
  ...task,
  ...user,
  ...event,
  ...administrativeReport,
  ...administrativeDashboard,
  ...ur,
  ...eixos,
  ...pacote,
  ...tema,
  ...salaIndicadores,
  ...salaIndicadoresMunicipio,
  ...salaIndicadoresApuracao,
  ...salaIndicadoresFonte,
  ...salaIndicadoresLeitura,
  ...salaIndicadoresNivel,
  ...salaIndicadoresUnidade,
  ...salaPrincipal,
  ...cargosFuncoes,
  ...sala5w2h,
  ...salaCusto,
  ...salaTempo,
  ...pergunta,
  ...medalha,
  ...configuracoes,
  ...groups,
  ...agenteTerritorial,
  ...eixosGrupo,
  ...municipiosPorEixos,
  ...diagnosticoSelo,
  ...tipoSolucao,
  ...clienteOculto,
  ...categorias,
  ...instituicao,
  ...gestaoTerritorios,
  ...faixas,
  ...escola,
  ...contratos,
  ...sp,
  ...municipiosTemasHabilitados,
  ...municipiosAds,
  ...recurso,
  ...technicalReview,
  ...resourceDashboard,
  ...technicalReviewDashboard,
  ...gestaoProjetos,
  ...iaColetaEvidencias,
  ...analiseEvidenciasIa,
  ...apresentacoes,
  ...analiseRelatoriosIa,
  ...cidadeEmpreendedoraNews,
  ...ec2Codex,
  ...radarExecucao,
  ...orcamento,
];
